export const SUMMARY_LOADING = 'SUMMARY_LOADING';
export const GET_SUMMARY_ORDER = 'GET_SUMMARY_ORDER';
export const UPLOAD_PAYMENT_SUPPORT = 'UPLOAD_PAYMENT_SUPPORT';
export const RESET_UPLOAD_PAYMENT_SUPPORT = 'RESET_UPLOAD_PAYMENT_SUPPORT';
export const UPLOAD_RUT = 'UPLOAD_RUT';
export const RESET_UPLOAD_RUT = 'RESET_UPLOAD_RUT';